import { takeLatest } from 'redux-saga/effects';
import * as types from './reducer';
import {getDealsSaga, getScheduleSaga} from "./handler";

export default function* watchDeals() {
    yield takeLatest(types.GET_DEALS, getDealsSaga);
    yield takeLatest(types.GET_SCHEDULE, getScheduleSaga);
}

